// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared look of the form popups (votings): fixed header with title and close button,
 * scrolling body, fixed footer with the actions. Opened with cssClass "form-modal", so on
 * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).
 * Loaded with @use by each popup stylesheet. */
:host {
  justify-content: flex-start;
  font-family: var(--ion-font-family, inherit);
  background: var(--ion-background-color, #fff);
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 0 0 auto;
  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-header__text {
  min-width: 0;
}
.popup-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.popup-header__subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin-top: 4px;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
}

.popup-close {
  display: grid;
  place-items: center;
  align-self: flex-start;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium-shade);
  line-height: 0;
  cursor: pointer;
}
.popup-close ion-icon {
  display: block;
  font-size: 21px;
}
.popup-close:hover, .popup-close:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}

.popup-body {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.popup-footer ion-button {
  margin: 0;
  min-width: 110px;
  height: 42px;
  --border-radius: 10px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}
@media (max-width: 575px) {
  .popup-footer ion-button {
    flex: 1;
  }
}

/* Section with a small uppercase title */
.popup-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.popup-section__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--ion-color-medium-shade);
}
.popup-section__title ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}

/* Field: label above a bordered input */
.popup-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.popup-field__label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ion-color-step-750, #404040);
}

.popup-input,
.popup-textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);
  background: var(--ion-background-color, #fff);
  color: var(--ion-text-color, #000);
  font: inherit;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.popup-input::placeholder,
.popup-textarea::placeholder {
  color: var(--ion-color-medium);
}
.popup-input:focus,
.popup-textarea:focus {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);
}

.popup-input {
  height: 48px;
  padding-top: 0;
  padding-bottom: 0;
}

.popup-textarea {
  min-height: 96px;
  line-height: 1.5;
  resize: vertical;
}

/* File row (attachments): icon, name (download), actions */
.file-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 8px 8px 8px 12px;
  border-radius: 10px;
  background: rgba(var(--ion-color-medium-rgb), 0.07);
}
.file-row > ion-icon {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-primary);
}
.file-row__name {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-row button.file-row__name {
  cursor: pointer;
}
.file-row button.file-row__name:hover, .file-row button.file-row__name:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  text-decoration: underline;
}

/* Small round icon button (remove, download) */
.icon-button {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.icon-button ion-icon {
  font-size: 18px;
}
.icon-button:hover, .icon-button:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.icon-button--danger:hover, .icon-button--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}

.leftChip {
  font-size: 15.5px;
  height: 28px;
  display: inline-block;
}

.noPointer {
  pointer-events: none;
}

.ion-chip-g-selected,
.ion-chip-g:hover {
  background-color: #e30f22;
  color: #fff;
  font-weight: bold;
}

.ion-chip-f-selected,
.ion-chip-f:hover {
  background-color: #bc4c4a;
  color: #fff;
  font-weight: bold;
}

.ion-chip-e-selected,
.ion-chip-e:hover {
  background-color: #e36c0e;
  color: #fff;
  font-weight: bold;
}

.ion-chip-d-selected,
.ion-chip-d:hover {
  background-color: #ffc118;
  color: #fff;
  font-weight: bold;
}

.ion-chip-c-selected,
.ion-chip-c:hover {
  background-color: #eded1d;
  color: #fff;
  font-weight: bold;
}

.ion-chip-b-selected,
.ion-chip-b:hover {
  background-color: #99cc18;
  color: #fff;
  font-weight: bold;
}

.ion-chip-a-selected,
.ion-chip-a:hover {
  background-color: #00cc15;
  color: #fff;
  font-weight: bold;
}

.ion-chip-ap-selected,
.ion-chip-ap:hover {
  background-color: #01950d;
  color: #fff;
  font-weight: bold;
}

.ion-chip-app-selected,
.ion-chip-app:hover {
  background-color: #005f05;
  color: #fff;
  font-weight: bold;
}

.ion-chip-appp-selected,
.ion-chip-appp:hover {
  background-color: #2c5e00;
  color: #fff;
  font-weight: bold;
}

.ion-chip-g {
  background-color: rgba(227, 15, 34, 0.1411764706);
  color: #fff;
  font-weight: bold;
}

.ion-chip-f {
  background-color: rgba(188, 76, 74, 0.1882352941);
  color: #fff;
  font-weight: bold;
}

.ion-chip-e {
  background-color: rgba(227, 108, 14, 0.2);
  color: #fff;
  font-weight: bold;
}

.ion-chip-d {
  background-color: rgba(255, 193, 24, 0.231372549);
  color: #fff;
  font-weight: bold;
}

.ion-chip-c {
  background-color: rgba(255, 255, 63, 0.2901960784);
  color: #fff;
  font-weight: bold;
}

.ion-chip-b {
  background-color: rgba(153, 204, 24, 0.3294117647);
  color: #fff;
  font-weight: bold;
}

.ion-chip-a {
  background-color: rgba(0, 204, 21, 0.2196078431);
  color: #fff;
  font-weight: bold;
}

.ion-chip-ap {
  background-color: rgba(1, 149, 13, 0.2509803922);
  color: #fff;
  font-weight: bold;
}

.ion-chip-app {
  background-color: rgba(0, 95, 5, 0.3019607843);
  color: #fff;
  font-weight: bold;
}

.ion-chip-appp {
  background-color: rgba(44, 94, 0, 0.2392156863);
  color: #fff;
  font-weight: bold;
}

.div-chip {
  width: 300px;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.icon-index-selected {
  transform: rotate(90deg);
  font-size: 30px;
  color: var(--ion-color-medium-shade);
}

.div-container-chip {
  width: 235px;
  max-width: 100%;
}

.div-master-chip {
  flex: 1 0 auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.label-definition {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  white-space: normal;
  color: var(--ion-color-medium-shade);
}`, "",{"version":3,"sources":["webpack://./src/theme/_popup-form.scss","webpack://./src/components/popup/popup-energy-coefficient/popup-energy-coefficient.component.scss"],"names":[],"mappings":"AAAA;;;+CAAA;AAKA;EACE,2BAAA;EACA,4CAAA;EACA,6CAAA;ACAF;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kEAAA;EACA,gEAAA;ACAF;ADEE;EACE,YAAA;ACAJ;ADGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACDJ;ADIE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;ACFJ;;ADMA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;ACHF;ADKE;EACE,cAAA;EACA,eAAA;ACHJ;ADME;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ACLJ;;ADSA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACNF;;ADSA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;EACA,gEAAA;EACA,6DAAA;ACNF;ADQE;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ACNJ;ADSE;EACE;IACE,OAAA;ECPJ;AACF;;ADWA,yCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACRF;ADUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;ACRJ;ADUI;EACE,eAAA;EACA,+BAAA;ACRN;;ADaA,wCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;ACVF;ADYE;EACE,eAAA;EACA,gBAAA;EACA,yCAAA;ACVJ;;ADcA;;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yDAAA;EACA,6CAAA;EACA,kCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;ACXF;ADaE;;EACE,8BAAA;ACVJ;ADaE;;EACE,sCAAA;EACA,8DAAA;ACVJ;;ADcA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;ACXF;;ADcA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;ACXF;;ADcA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mDAAA;ACXF;ADaE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ACXJ;ADcE;EACE,OAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACZJ;ADeE;EACE,eAAA;ACbJ;ADeI;EAEE,aAAA;EACA,+BAAA;EACA,0BAAA;ACdN;;ADmBA,+CAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AChBF;ADkBE;EACE,eAAA;AChBJ;ADmBE;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;AClBJ;ADqBE;EAEE,8BAAA;EACA,kDAAA;ACpBJ;;AArOA;EACE,iBAAA;EACA,YAAA;EACA,qBAAA;AAwOF;;AArOA;EACE,oBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;;EAEE,yBAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,iDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,iDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,yCAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,iDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,kDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,kDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,gDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,gDAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,8CAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,+CAAA;EACA,WAAA;EACA,iBAAA;AAwOF;;AArOA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAwOF;;AArOA;EACE,wBAAA;EACA,eAAA;EACA,oCAAA;AAwOF;;AArOA;EACE,YAAA;EACA,eAAA;AAwOF;;AArOA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAwOF;;AArOA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;AAwOF","sourcesContent":["/* Shared look of the form popups (votings): fixed header with title and close button,\n * scrolling body, fixed footer with the actions. Opened with cssClass \"form-modal\", so on\n * tablet/desktop the modal is a 560px card as tall as its content (body capped at 60vh).\n * Loaded with @use by each popup stylesheet. */\n\n:host {\n  justify-content: flex-start;\n  font-family: var(--ion-font-family, inherit);\n  background: var(--ion-background-color, #fff);\n}\n\n.popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex: 0 0 auto;\n  padding: calc(16px + var(--ion-safe-area-top, 0px)) 12px 12px 20px;\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  &__text {\n    min-width: 0;\n  }\n\n  h2 {\n    margin: 0;\n    font-size: 17px;\n    font-weight: 600;\n    line-height: 1.35;\n    overflow-wrap: anywhere;\n  }\n\n  &__subtitle {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 10px;\n    margin-top: 4px;\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n  }\n}\n\n.popup-close {\n  display: grid;\n  place-items: center;\n  align-self: flex-start;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium-shade);\n  line-height: 0;\n  cursor: pointer;\n\n  ion-icon {\n    display: block;\n    font-size: 21px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n}\n\n.popup-body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n}\n\n.popup-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n  padding: 12px 20px calc(12px + var(--ion-safe-area-bottom, 0px));\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n  ion-button {\n    margin: 0;\n    min-width: 110px;\n    height: 42px;\n    --border-radius: 10px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n\n  @media (max-width: 575px) {\n    ion-button {\n      flex: 1;\n    }\n  }\n}\n\n/* Section with a small uppercase title */\n.popup-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      font-size: 16px;\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n/* Field: label above a bordered input */\n.popup-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n\n  &__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--ion-color-step-750, #404040);\n  }\n}\n\n.popup-input,\n.popup-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.35);\n  background: var(--ion-background-color, #fff);\n  color: var(--ion-text-color, #000);\n  font: inherit;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &::placeholder {\n    color: var(--ion-color-medium);\n  }\n\n  &:focus {\n    border-color: var(--ion-color-primary);\n    box-shadow: 0 0 0 3px rgba(var(--ion-color-primary-rgb), 0.18);\n  }\n}\n\n.popup-input {\n  height: 48px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.popup-textarea {\n  min-height: 96px;\n  line-height: 1.5;\n  resize: vertical;\n}\n\n/* File row (attachments): icon, name (download), actions */\n.file-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 8px 8px 8px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-medium-rgb), 0.07);\n\n  > ion-icon {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-primary);\n  }\n\n  &__name {\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 14px;\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  button.file-row__name {\n    cursor: pointer;\n\n    &:hover,\n    &:focus-visible {\n      outline: none;\n      color: var(--ion-color-primary);\n      text-decoration: underline;\n    }\n  }\n}\n\n/* Small round icon button (remove, download) */\n.icon-button {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n\n  ion-icon {\n    font-size: 18px;\n  }\n\n  &:hover,\n  &:focus-visible {\n    outline: none;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.1);\n  }\n\n  &--danger:hover,\n  &--danger:focus-visible {\n    color: var(--ion-color-danger);\n    background: rgba(var(--ion-color-danger-rgb), 0.1);\n  }\n}\n","@use \"../../../theme/popup-form\";\n\n.leftChip {\n  font-size: 15.5px;\n  height: 28px;\n  display: inline-block;\n}\n\n.noPointer {\n  pointer-events: none;\n}\n\n.ion-chip-g-selected,\n.ion-chip-g:hover {\n  background-color: #e30f22;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-f-selected,\n.ion-chip-f:hover {\n  background-color: #bc4c4a;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-e-selected,\n.ion-chip-e:hover {\n  background-color: #e36c0e;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-d-selected,\n.ion-chip-d:hover {\n  background-color: #ffc118;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-c-selected,\n.ion-chip-c:hover {\n  background-color: #eded1d; //#ffff3f;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-b-selected,\n.ion-chip-b:hover {\n  background-color: #99cc18;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-a-selected,\n.ion-chip-a:hover {\n  background-color: #00cc15;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-ap-selected,\n.ion-chip-ap:hover {\n  background-color: #01950d;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-app-selected,\n.ion-chip-app:hover {\n  background-color: #005f05;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-appp-selected,\n.ion-chip-appp:hover {\n  background-color: #2c5e00;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-g {\n  background-color: #e30f2224;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-f {\n  background-color: #bc4c4a30;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-e {\n  background-color: #e36c0e33;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-d {\n  background-color: #ffc1183b;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-c {\n  background-color: #ffff3f4a;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-b {\n  background-color: #99cc1854;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-a {\n  background-color: #00cc1538;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-ap {\n  background-color: #01950d40;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-app {\n  background-color: #005f054d;\n  color: #fff;\n  font-weight: bold;\n}\n\n.ion-chip-appp {\n  background-color: #2c5e003d;\n  color: #fff;\n  font-weight: bold;\n}\n\n.div-chip {\n  width: 300px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.icon-index-selected {\n  transform: rotate(90deg);\n  font-size: 30px;\n  color: var(--ion-color-medium-shade);\n}\n\n.div-container-chip {\n  width: 235px;\n  max-width: 100%;\n}\n\n.div-master-chip {\n  flex: 1 0 auto;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.label-definition {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: normal;\n  color: var(--ion-color-medium-shade);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
